import { submitApplication } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import { toNormalizedSnsAccounts } from './sns-account.service';
import type {
  SubmitJoinApplicationServiceRequest,
  SubmitJoinApplicationServiceResponse,
} from './submit-join-application.dto';
import {
  SubmitJoinApplicationServiceRequestSchema,
  SubmitJoinApplicationServiceResponseSchema,
} from './submit-join-application.dto';

export const submitJoinApplicationService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(SubmitJoinApplicationServiceRequestSchema),

    async (
      request: SubmitJoinApplicationServiceRequest,
    ): Promise<SubmitJoinApplicationServiceResponse> => {
      const transformedRequest = {
        ...request,
        snsAccounts: toNormalizedSnsAccounts(request.snsAccounts),
      };

      const { data } = await submitApplication(transformedRequest);

      return {
        curatorId: data.curatorId,
      };
    },

    validateServiceResponse(SubmitJoinApplicationServiceResponseSchema),
  ),
);
